/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { Banner as BannerMain } from './main.tsx';

export function Banner(): React.JSX.Element | null {
	return <BannerMain />;
}
